import {
  ADD_TO_CART,
  DELETE_ITEM,
  UPDATE_CARTITEM_QUANTITY,
} from "./actionType";

const initialState = [];

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART:
      const product = state.find((item) => item.id === action.payload.id);
      if (product) {
        return state.map((item) =>
          item.id === action.payload.id
            ? { ...item, cartQuantity: item.cartQuantity + 1 }
            : item
        );
      } else {
        return [...state, action.payload];
      }

    case UPDATE_CARTITEM_QUANTITY:
      return state.map((item) =>
        item.id === action.payload.id
          ? {
              ...item,
              cartQuantity:
                action.payload.type === "+"
                  ? item.cartQuantity + 1
                  : item.cartQuantity - 1,
            }
          : item
      );

    case DELETE_ITEM:
      return state.filter((item) => item.id !== action.payload);

    default:
      return state;
  }
};

export default cartReducer;
